'use strict';

var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;

var definition = {
  name: 'Site',
  basePath: ':basePath',
  endpoint: 'sites',
  debug: false, // toggle debugging for individual models
  methods: null,
  relations : {
    hasMany : {
      DataCapture : {
        localField : 'dataCaptures',
        foreignKey: 'siteId'
      },
      Annotation : {
        localField : 'annotations',
        foreignKey : 'siteId'
      },
      Measurement: {
        localField: 'measurements',
        foreignKey: 'siteId'
      },
      Overlay: {
        localField: 'overlays',
        foreignKey: 'siteId'
      }
    },
    belongsTo: {
      Project: {
        localField: 'project',
        localKey: 'projectId'
      }
    }
  }
};

var SiteResource = function(DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

var getResourceOptions = function(options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    name : 'Site',
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {

      // Supports the `slug=:slug` syntax on backend
      findBySlug : function(name, params, options) {
        return this.find('slug=' + name, params, options);
      },

      getDefaultDataCapture : function getDefaultDataCapture (siteId) {
        var params = {
          include : 'dataCaptures,dataCaptures.dataCaptureLayers',
          linkInverse: false
        };
        return this.find(siteId, { params : params }).then(function(site){
          return site.getDefaultDataCapture();
        });
      }

    },

    modelMethods: {
      getDefaultDataCapture : function() {
        // TODO: Determine what is the default datacapture for a site
        // (currently returning the latest, filtering by `capturedAt`)
        // This method also assumes the datacaptures have been fetched.
        // In case they haven't check that datacaptures is null and fetch, must
        // return a promise.
        var filtered = this.dataCaptures.filter(function(dc) {
          return dc.dataCaptureLayers && dc.dataCaptureLayers.length > 0 &&
            dc.dataCaptureLayers.some(function(layer) {
              return layer.layerType === 'tileLayer';
            });
        });
        var ordered = filtered.sort(function(a, b) {
          return new Date(a.capturedAt) - new Date(b.capturedAt);
        });
        return ordered[ordered.length - 1];
      }
    },

    // definition formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri
      }
    },

    // sync trigger definitions
    // the model trigger definitions will be initiliazed and attached to every collection model
    syncTriggers: {
      // collection: [{
      //   type: 'firebase',
      //   basePath: options.fbBaseUri,
      //   endpoint: 'sites/lastUpdated',
      //   token: options.fbAuthToken
      // }, {
      //   type: 'firebase',
      //   basePath: options.fbBaseUri,
      //   endpoint: 'sites2/lastUpdated',
      //   token: options.fbAuthToken
      // }],
      // model: [{
      //   type: 'firebase',
      //   basePath: options.fbBaseUri,
      //   endpoint: 'sites/:modelId/lastUpdated',
      //   token: options.fbAuthToken
      // }]
    }
  };
};

module.exports = SiteResource;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/site/SiteResource.js